import { FC } from "react";
// import appStore from "../stores/appStore";
import { Link } from "react-router";
// import appStore from "../stores/appStore";

const Footer: FC = () => {
  return (
    <footer>
      <div className="flex flex-row p-4 text-white justify-around">
        <div className="flex flex-col w-[30%]">
          <div className="flex flex-col gap-1.5">
            <span className="text-5xl font-bold text-left">КЦ Авто</span>
            <span className="text-xs tracking-[-0.02em]  font-normal text-left">
              © {new Date().getFullYear()} ИП Боровиков Григорий Владимирович
            </span>
          </div>
          <div className="mt-5">
            <p className="text-left text-xs w-full">
              КЦ Авто — сеть магазинов автозапчастей
              {/* с точками в {" "}
                {appStore.cities.map((i) => {
                    return <>{i.name} </>
                })} */}
            </p>
          </div>
        </div>
        <div className="flex flex-col">
          <span className="text-2xl font-semibold text-left">Информация</span>
          <div className="mt-3 flex flex-col text-left !font-medium">
            <Link to={"/about"}>О компании</Link>
            <Link to={"/about"}>Доставка и оплата</Link>
            <Link to={"/about/terms"}>Условия использования</Link>
            <Link to={"/about/privacy"}>Политика конфиденциальности</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
